import * as React from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { useOfferContext } from '../../../context';
import {
  getRentPrice,
  getMoreRentPrice,
  getFee,
  getClientFee,
  getDeposit,
  getAgentBonus,
  getSalePrice,
  getSalePricePerMeter,
  getCommercialRentPrice,
  getCommercialPerMeterByYear,
  getCommercialLandPerMeterByYear,
  getSaleType,
  isCommercial,
  isCommercialLand,
  isRent,
  isSuburban,
} from '../../../utils/offers';
import { Price } from 'shared/components/OfferCard/Price';
import { selectUser } from 'shared/slices';

export const OfferPriceContainer = () => {
  const { offer } = useOfferContext();
  const user = useSelector(selectUser, shallowEqual);

  const {
    bargainTerms,
    dealType,
    category,
    totalArea,
    offerType,
    priceTotalPerMonthRur,
    pricePerUnitAreaPerYearRur,
    land,
  } = offer;

  const terms = React.useMemo(() => {
    if (isCommercial(offerType) || isCommercialLand(category)) {
      const terms = [];
      if (isRent(dealType)) {
        terms.push(getCommercialRentPrice(category, priceTotalPerMonthRur));
        if (isCommercialLand(category)) {
          terms.push(getCommercialLandPerMeterByYear({ pricePerUnitAreaPerYearRur, land }));
        } else {
          terms.push(getCommercialPerMeterByYear(pricePerUnitAreaPerYearRur));
        }

        return terms;
      }

      return [getSalePrice(bargainTerms), getSalePricePerMeter({ bargainTerms, totalArea }), getSaleType(bargainTerms)];
    }

    if (isRent(dealType)) {
      return [
        getRentPrice(category, bargainTerms),
        getMoreRentPrice(category, bargainTerms),
        user.isAuthenticated && Boolean(user.isAgent) ? getFee(bargainTerms) : getClientFee(bargainTerms),
        getDeposit(bargainTerms),
        getAgentBonus(user, bargainTerms),
      ];
    }

    const priceData = [getSalePrice(bargainTerms)];

    if (isSuburban(category)) {
      priceData.push(getSalePricePerMeter({ bargainTerms, totalArea }) as string);
    }

    priceData.push(getAgentBonus(user, bargainTerms));

    return priceData;
  }, [
    bargainTerms,
    category,
    dealType,
    land,
    offerType,
    pricePerUnitAreaPerYearRur,
    priceTotalPerMonthRur,
    totalArea,
    user,
  ]);

  if (!bargainTerms) {
    return null;
  }

  return <Price terms={terms} />;
};
